export default __webpack_public_path__ + "static/media/screen2.8a680900.svg";